const utils = require('../../../lib/utils')

module.exports = {
    methods: {
        showMessage: function(content, isError = false){
            if(!this.$) return;

            // reset styles
            const $target = this.$.find('.messageContainer')

            if($target.length > 0){
                $target
                    .removeClass('visible')
                    .removeClass('error')
                    .css('opacity', 0)
                    .css('height', 'auto')

                // set new message
                $target.find('.message').html(content)

                // mesaure height
                const height = $target.height()

                // scroll to message container
                $('html, body').animate({ scrollTop: Math.max(0, (($target.offset() || {}).top || 0) - 100) }, 50, false);

                // animate show message
                const addClasses = ['visible']
                if(isError) addClasses.push('error');
                $target
                    .css('height', 0)
                    .addClass(addClasses)
                    .css('opacity', 1)
                    .css('height', `${height}px`)
            }
        },

        prepare: function(){
            this.find('base_form_form', form => {
                if((form.resourceData || {}).error){
                    this.model.error = form.resourceData.error
                }
                this.config.isPostAuth = (form.config || {}).isPostAuth
                return 'break'
            })
        },

        handleError: function(context){
            const apiError = utils.extractBaseError(context.error) || {};

            if(apiError.statusCode <= 500){
                this.showMessage(`<p>${storage.__(`error:events.registration.${apiError.errorCode || apiError.statusCode}`)}</p>`, true)
            }

            context.errorUnhandled = true;
            return utils.promise.resolve(context);
        },
    },

    handlers: [{
        name: 'onSubmitDone',
        componentClass: 'base_bootstrap5_events_applicantRegistrationForm',
        handle: function(callerComponent, nodeData, insertPerformed){
            if(callerComponent.config.isPostAuth) {
                this.showMessage(`<p>${storage.__(`events.registration.postAuthSubmitDone`)}</p>`, false)
            } else {
                this.showMessage(`<p>${storage.__(`events.registration.eventRegistrationMailSent`)}</p>`, false)
            }
        }
    }]
}

